import { SidePanelPageLayoutTsoPq } from '@components/Grid/GridTsoPq';
import { SidePanelTsoPq } from '@components/Grid/SidePanelTsoPq';
import TypographyTsoPq from '@components/Typography/TypographyTsoPq';
import { useTranslation } from 'react-i18next';

import {
  StyledContent,
  StyledContentTitle,
  StyledContentWrapper,
  StyledHeaderContainer,
} from '../HarmonicBackgroundLevel/harmonicBackgroundLevelStyles';

import CorrelationParameters from './CorelationParameters/CorrelationParametersSection';
import CorrelationChart from './CorrelationChart';

export const Correlation = () => {
  const { t } = useTranslation();

  return (
    <SidePanelPageLayoutTsoPq
      sidePanel={<SidePanelTsoPq sectionTitle={t('correlation.sectionTitle')} firstSlot={<CorrelationParameters />} />}
      content={
        <StyledContentWrapper>
          <StyledContent>
            <StyledHeaderContainer>
              <StyledContentTitle>
                <TypographyTsoPq typographyType="pageTitleBold">{t('correlation.pageTitle')}</TypographyTsoPq>
                <TypographyTsoPq typographyType="pageSubtitleSM">{t('correlation.pageSubtitle')}</TypographyTsoPq>
              </StyledContentTitle>
            </StyledHeaderContainer>
            <CorrelationChart />
          </StyledContent>
        </StyledContentWrapper>
      }
    />
  );
};
